import { createSelector } from "@reduxjs/toolkit";
import { initialState } from "./index";

const selectDropdownState = (state) => state.dropdown || initialState;

export const selectCategories = createSelector(
  [selectDropdownState],
  (state) => state.categories
);

export const selectLanguages = createSelector(
  [selectDropdownState],
  (state) => state.languages
);

export const selectCompanies = createSelector(
  [selectDropdownState],
  (state) => state.companies
);

export const selectCities = createSelector(
  [selectDropdownState],
  (state) => state.cities
);

export const selectStates = createSelector(
  [selectDropdownState],
  (state) => state.states
);

export const selectPrimaryCategories = createSelector(
  [selectDropdownState],
  (state) => state.primaryCategories
);

export const selectSubCategories = createSelector(
  [selectDropdownState],
  (state) => state.subCategories
);

export const selectTalentAgencyManagers = createSelector(
  [selectDropdownState],
  (state) => state.talentAgencyManagers
);

export const selectCreatorPlans = createSelector(
  [selectDropdownState],
  (state) => state.creatorPlans
);
